import type { LayoutSpec } from '../../../types/LayoutConfig';

/** Shared layout templates must not carry per-user sidebar grouping. */
export function layoutSpecForSharing(spec: LayoutSpec): LayoutSpec {
  const { group: _group, ...rest } = spec;
  return rest;
}
